
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/crossword",
      function () {
        return require("private-next-pages/games/crossword/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/crossword"])
      });
    }
  